import { Link } from "react-router-dom"
import React from "react"

export default function CompanyCard(props) {
  const logoUrl = require(`../../assets/company-images/${props.image}`)
  return (
    <Link to={`${props.link}`} className="link">
      <div
        className="company-card border-box"
        style={{
          width: "80px",
          height: "80px",
          margin: "5px",
          borderRadius: "30%",
          overflow: "hidden",
          background: 'white'
        }}
      >
        <img
          src={logoUrl}
          alt="company-logo"
          style={{
            width: "80%",
          }}
        />
      </div>
    </Link>
  )
}
